module.exports = __webpack_public_path__ + "a2fe832deed7dba26a639b39bf2523a7.svg";